const { addDays, isAfter, parseISO } = require('date-fns');

// The server compares dates in its own timezone and the browser in the user's, so they can differ by a few hours at the 2-day and 1-day limits.
function hasMembershipWithinTwoDays(memberships, now) {
  if (!memberships) return false;
  return memberships.some((membership) => isAfter(addDays(parseISO(membership.validity), 2), now));
}

function hasFreeTrialWithinOneDay(user, now) {
  if (!user.got_free_trial) return false;
  return isAfter(addDays(parseISO(user.got_free_trial), 1), now);
}

// Mirrors igs3-server src/middleware/trainingSystemMembership.ts, which guards
// GET /api/discuss and PUT /api/trainingSystem/studied.
function hasTrainingSystemAccess(isLoggedIn, user, memberships, now) {
  if (!isLoggedIn) return false;
  if (!user) return false;
  // No author check: the server's login token never carries author, so its author check is never true.
  if (user.admin) return true;
  if (user.teacher) return true;
  if (user.translator) return true;
  if (hasMembershipWithinTwoDays(memberships, now)) return true;
  if (hasFreeTrialWithinOneDay(user, now)) return true;
  return false;
}

module.exports = { hasTrainingSystemAccess };
